import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Typography, List, ListItem, Divider } from "@material-ui/core";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams,
    useRouteMatch,
    useLocation
} from "react-router-dom";
import BasePage from "../../base/BasePage";
import * as RFIcon from 'react-feather'; 
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ProfileEntity from "../../entities/profile"
import {auth} from "../../firebase";
import ChangePassword from "./components/ChangePassword";
import language from "../../languages";

const useStyles = makeStyles((theme) => ({
    filterGrid: {
        minHeight: '100vh',
        backgroundColor: '#F3F6FF',
        color: '#2735A4'
    },
    settingMenuHeader: {
        paddingTop: 15,
        paddingBottom: 14,
        color: '#09205C',
        backgroundColor: '#ffffff',
        '& .MuiListItemIcon-root' : {
            color: '#09205C'
          }
    },
    divider: {
        backgroundColor:"#2735A4",
        height: 2
    },
    selectedItem: {
      backgroundColor: 'rgba(39,53,164,0.4) !important',
      color: '#ffffff',
      '& .MuiListItemIcon-root' : {
        color: '#ffffff'
      }
    },
    itemList: {
      '& .MuiListItemIcon-root' : {
        color: '#2735A4'
      }
    },
    itemText: {
        fontWeight: 500,
        fontSize: '1.2rem'
    }
}));

const PROFILE_MENU = [
    {
        name: "General",
        to: 'general',
        icon: <RFIcon.Tool strokeWidth={2}/>
    },
    {
        name: "Change Password",
        to: 'change-password',
        icon: <RFIcon.Lock strokeWidth={2} />
    }
  ];

export default function ProfilePage(props) {
    const { path, url } = useRouteMatch();
    const { user, roles, theme, openSnackbar, appSettings } = props;
    const classes = useStyles();
    let location = useLocation();
    const pathName = location.pathname;
    const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';

    return (
        <Grid container>
            <Grid item xs={12} md={2} className={classes.filterGrid} >
                
                <ListItem className={classes.settingMenuHeader}>
                    <ListItemIcon> <RFIcon.User strokeWidth={2}/> </ListItemIcon>
                    <ListItemText disableTypography={true} primary={language[lang].My_Profile} className={classes.itemText} />
                </ListItem>
                    
                <Divider className={classes.divider} />
                <List disablePadding={true}>
                    {PROFILE_MENU.map((menuItem, index) => (
                        <ListItem className={(pathName == `${url}/${menuItem.to}`) ? classes.selectedItem : classes.itemList} button
                        key={index}
                        component={Link}
                        to={`${url}/${menuItem.to}`}

                        selected={pathName == `${url}/${menuItem.to}`}>
                        <ListItemIcon> {menuItem.icon} </ListItemIcon>
                        <ListItemText primary={menuItem.name} />
                        </ListItem>
                    ))}
                </List>
            </Grid> 
            

            <Grid item xs={12} md={10}>
                <Box>
                    <Switch>
                        <Route exact path={path} key="profile1">
                            <BasePage roles={roles}
                                meta={ProfileEntity(auth.currentUser.uid, lang)}
                                user={user}
                                theme={theme}
                                appSettings={appSettings}
                                openSnackbar={openSnackbar} />
                        </Route>
                        <Route path={`${path}/general`} key="generalProfile">
                            <BasePage roles={roles}
                                meta={ProfileEntity(auth.currentUser.uid, lang)}
                                user={user}
                                theme={theme}
                                appSettings={appSettings}
                                openSnackbar={openSnackbar} />
                        </Route>
                        <Route path={`${path}/change-password`} key="change-password">
                            <ChangePassword roles={roles}
                                user={user}
                                theme={theme}
                                appSettings={appSettings}
                                openSnackbar={openSnackbar} />
                        </Route>
                    </Switch>
                </Box>
            </Grid>
        </Grid>       
    );
}